export default {
    data: () => ({
        translations: {
            paymentMethod: {
                el: "Eπιλέξτε μέθοδο πληρωμής",
                en: "Please Choose Payment Method",
                it: "Scegliere il metodo di pagamento"
            },
            save: {
                el: "Αποθήκευση",
                en: "Save",
                it: "Risparmiare"
            },
            title: {
                el: "Τιμολόγηση",
                en: "Billing",
                it: "Fatturazione"
            },
            billingDetails: {
                el: "Στοιχεία Τιμολόγησης",
                en: "Billing Details",
                it: "Dettagli di fatturazione"
            },
            info: {
                el: `
                Εδώ μπορείτε να δείτε τον πίνακα ελέγχου χρέωσης, να δείτε τις μελλοντικές και προηγούμενες πληρωμές σας και να προσθέσετε ή να αφαιρέσετε μεθόδους πληρωμής.
                    `,
                en: `
                Here you can view your billing dashboard, you can see your future and past payments and add or remove payment methods.
                    `,
                it:  `
                Qui puoi visualizzare la dashboard di fatturazione, puoi vedere i tuoi pagamenti futuri e passati e aggiungere o rimuovere metodi di pagamento.
                    `
            },
            subscriptionPlan: {
                el: "Συνδρομή",
                en: "Subscription Plan",
                it: "Abbonamento"
            },
            paymentHistory: {
                el: "Ιστορικό Πληρωμών",
                en: "Payment History",
                it: "Storia dei pagamenti"
            },
            pastPayments: {
                el: "Προηγούμενες πληρωμές",
                en: "Past Payments",
                it: "Pagamenti precedenti"
            },
            nextPeriod: {
                el: "Επόμενη Περίοδος χρέωσης",
                en: "Next Billing Period",
                it: "Periodo di fatturazione successivo"
            },
            period: {
                el: "Περίοδος χρέωσης",
                en: "Billing Period",
                it: "Periodo di fatturazione"
            },
            viewMore:{
                el: "Δείτε περισσότερα",
                en: "View More",
                it: "Per saperne di più"
            },
            downloadPdf:{
                el: "Λήψη αρχείου Pdf",
                en: "Download Pdf File",
                it: "Scarica il file Pdf"
            },
            total: {
                el: "Σύνολο",
                en: "Total",
                it: "Totale"
            },
            beforeVat: {
                el: "προ ΦΠΑ",
                en: "before Vat",
                it: "prima dell'Iva"
            },
            
            final: {
                el: "τελικό",
                en: "final",
                it: "definitivo"
            },
            paymentStatus: {
                el: "Κατάσταση Πληρωμών",
                en: "Payment Status",
                it: "Stato di pagamento"
            },
            status: {
                el: "Κατάσταση",
                en: "Status",
                it: "Stato"
            },
            payment_date: {
                el: "Ημερομηνία Πληρωμής",
                en: "Payment Date",
                it: "Data di pagamento"
            },
            date: {
                el: "Ημερομηνία",
                en: "Date",
                it: "Data"
            },
            next_payment_date: {
                el: "Επόμενη Πληρωμή",
                en: "Next Payment Date",
                it: "Prossima data di pagamento"
            },
            pending: {
                el: "τρέχον",
                en: "pending",
                it: "in attesa"
            },
            toBePaid: {
                el: "",
                en: "to be paid",
                it: ""
            },
            paid: {
                el: "εξοφλημένo",
                en: "paid",
                it: "Pagato"
            },
            unpaid: {
                el: "ανεξόφλητo",
                en: "unpaid",
                it: "Pagato"
            },
            paginationText: {
                el: "από",
                en: "of",
                it: "di"
            },
            cardNumber: {
                el: "Αριθμός",
                en: "Number",
                it: "Numero"
            },
            active: {
                el: "Ενεργή",
                en: "Active",
                it: "Attivo"
            },
            actions: {
                el: "Ενέργειες",
                en: "Actions",
                it: "Azioni" 
            },
            cards: {
                el: "Cards",
                en: "Cards",
                it: "Cards" 
            },
            delete: {
                el: "Διαγραφή",
                en: "Delete",
                it: "Cancellare"
            },
            deleteMethodTitle: {
                el: "Διαγραφή Μεθόδου Πληρωμής",
                en: "Delete Payment Method",
                it: "Cancellare Metodo di pagamento"
            },
            deleteMethodQuestion: {
                el: "Είστε σίγουροι ότι θέλετε να διαγράψετε την μέθοδο πληρωμής;",
                en: "Are you sure you want to delete this payment method?",
                it: "È sicuro di voler eliminare la metodo di pagamento?"
            },
            activate: {
                el: "Ενεργοποίηση",
                en: "Activate",
                it: "Attivare"
            },
            addCard: {
                el: "Προσθήκη κάρτας",
                en: "Add Card",
                it: "Aggiungi scheda"
            },
            addMethod: {
                el: "Προσθήκη μεθόδου πληρωμής",
                en: "Add Payment Method",
                it: "Aggiungi metodo di pagamento"
            },
            authenticatePayment: {
                el: "Πιστοποίηση πληρωμής",
                en: "Authenticate Payment",
                it: "Autenticare il pagamento"
            },
            headerService: {
                el: "Υπηρεσία",
                en: "Service",
                it: "Servizio"
            },
            headerUnitValue: {
                el: "Αξία μονάδας",
                en: "Unit Value",
                it: "Valore unitario"
            },
            headerQuantity: {
                el: "Ποσότητα",
                en: "Quantity",
                it: "Quantità"
            },
            headerTotal: {
                el: "Σύνολο",
                en: "Total",
                it: "Totale"
            },
            currentCharges: {
                el: "Τρέχουσες Χρεώσεις",
                en: "Current Charges",
                it: "Spese correnti"
            },
            currentTotal: {
                el: "Τρέχον Σύνολο",
                en: "Current Total",
                it: "Totale attuale"
            },
            currentBillingSum: {
                el: "Σύνοψη επόμενης χρέωσης",
                en: "Next Billing Summary",
                it: "Prossimo riepilogo della fatturazione"
            },
            paymentInfo: {
                el: "Πληροφορίες πληρωμής",
                en: "Payment Information",
                it: "Informazioni sul pagamento"
            },
            totalEstimated: {
                el: "Εκτιμώμενο Σύνολο",
                en: "Total Estimated",
                it: "Totale stimato"
            },
            subscription: {
                el: "Τρέχουσες Χρεώσεις",
                en: "subscription",
                it: "Spese correnti"
            },
            price: {
                el: "Τιμή",
                en: "Price",
                it: "Prezzo"
            },
            expirationDate: {
                el: "Λήξη",
                en: "Expiration Date",
                it: "Data di scadenza"
            },
            startDate: {
                el: "Έναρξη",
                en: "Start Date",
                it: "Data di inizio"
            },
            inactive: {
                el: "Ανενεργή",
                en: "Inactive",
                it: "Inattivo"
            },
            ok: {
                el: "OK",
                en: "OK",
                it: "OK"
            },
            stripe_ok: {
                el: "OK",
                en: "OK",
                it: "OK"
            },
            choosePaymentMethodError: {
                el: "Δεν έχει επιλεγεί μέθοδος πληρωμής, Παρακαλώ επιλέξτε/προσθέστε μια μέθοδο πληρωμής.",
                en: "No payment method selected, Please choose/add a payment method.",
                it: "Non è stato selezionato alcun metodo di pagamento, Si prega di scegliere/aggiungere un metodo di pagamento."
            },
            
            choosePaymentMethodError1: {
                el: "Μεταβείτε στη σελίδα ",
                en: "Go to page ",
                it: "Vai alla pagina "
            },
            choosePaymentMethodError2: {
                el: "Μέθοδοι πληρωμών",
                en: "Payment Methods",
                it: "Metodi di pagamento"
            },
            choosePaymentMethodError3: {
                el: " για να επιλέξετε έναν για τη συνδρομή σας.",
                en: " to select one for your subscription.",
                it: " per sceglierne uno per il tuo abbonamento."
            },
            
            selectedMethod: {
                el: "Επιλεγμένη Μέθοδος Πληρωμής",
                en: "Selected Payment Method",
                it: "Metodo di pagamento selezionato"
            },
            
            method: {
                el: "Τρόπος Πληρωμής",
                en: "Payment Method",
                it: "Metodo di pagamento"
            },
            methodStatus_ok: {
                el: "OK",
                en: "OK",
                it: "OK"
            },
            methodStatus_stripe_ok: {
                el: "OK",
                en: "OK",
                it: "OK"
            },
            methodStatus_pending_payment: {
                el: "Εκκρεμεί Πληρωμή",
                en: "Pending Payment",
                it: "In Attesa di Pagamento"
            },
            methodStatus_description_pending_payment: {
                el: "Υπάρχει μια εκκρεμής πληρωμή που πρέπει να διεκπεραιωθεί από την πλευρά σας.",
                en: "There is a pending payment that needs to be handled from your side.",
                it: "C'è un pagamento in sospeso che deve essere gestito da parte vostra."
            },
            methodStatus_stripe_no_card: {
                el: "Χωρίς Κάρτα",
                en: "No Card",
                it: "Nessuna Carta"
            },
            methodStatus_description_stripe_no_card: {
                el: "Πρέπει να προσθέσετε μια κάρτα πληρωμής.",
                en: "You need to add a payment card.",
                it: "È necessario aggiungere una carta di pagamento."
            },
            methodStatus_stripe_no_payment_method: {
                el: "Χωρίς Μέθοδο Πληρωμής",	
                en: "No Payment Method",
                it: "Nessuna Metodo di Pagamento"
            },
            methodStatus_description_stripe_no_payment_method: {
                el: "Πρέπει να προσθέσετε μια μέθοδο πληρωμής.",
                en: "You need to add a payment method.",
                it: "È necessario aggiungere una metodo di pagamento."
            },
            methodStatus_stripe_failed_payment: {
                el: "Αποτυχημένη Πληρωμή",
                en: "Failed Payment",
                it: "Pagamento non Riuscito"
            },
            methodStatus_stripe_pending_payment: {
                el: "Υπάρχει μια εκκρεμής πληρωμή που πρέπει να διεκπεραιωθεί από την πλευρά σας.",
                en: "There is a pending payment that needs to be handled from your side.",
                it: "C'è un pagamento in sospeso che deve essere gestito da parte vostra."
            },
            methodStatus_description_stripe_failed_payment: {
                el: "Η απόπειρα πληρωμής με την καταχωρημένη κάρτα σας οδηγεί σε αποτυχία. Παρακαλούμε, ελέγξτε τον τραπεζικό σας λογαριασμό ή προσθέστε μια νέα κάρτα.",
                en: "Attempting a payment with your registered card leads to failure. Please, check with your bank account or add a new card.",
                it: "Il tentativo di pagamento con la carta registrata è fallito. Si prega di controllare il proprio conto bancario o di aggiungere una nuova carta."
            },
            methodStatus_stripe_authentication_required: {
                el: "Απαιτείται Αυθεντικοποίηση",
                en: "Authentication Required",
                it: "Autenticazione Richiesta"
            },
            methodStatus_description_stripe_authentication_required: {
                el: "Η πληρωμή απαιτεί έλεγχο ταυτότητας από την πλευρά σας για να προχωρήσει.",
                en: "Payment requires authentication from your side to proceed.",
                it: "Per procedere al pagamento è necessaria l'autenticazione da parte dell'utente."
            },
            methodStatus_stipe_add_card: {
                el: "Προσθήκη Κάρτας",
                en: "Add Card",
                it: "Aggiungere la Carta"
            },
            methodStatus_stipe_add_method: {
                el: "Προσθήκη μεθόδου πληρωμής",
                en: "Add Payment Method",
                it: "Aggiungere metodo di pagamento"
            },
            methodStatus_description_stipe_add_card: {
                el: "Πρέπει να προσθέσετε μια κάρτα πληρωμής.",
                en: "You need to add a payment method.",
                it: "È necessario aggiungere una carta di pagamento."
            },
            methodStatus_description_stipe_add_method: {
                el: "Πρέπει να προσθέσετε μια μέθοδο πληρωμής.",
                en: "You need to add a payment method.",
                it: "È necessario aggiungere una metodo di pagamento."
            },
            noPaymentMethodNeededTitle: {
                el: "Δεν απαιτείται μέθοδος πληρωμής",
                en: "No Payment Method Needed ",
                it: "Non è necessario alcun metodo di pagamento"
            },
            noPaymentMethodNeededDescription: {
                el: "Το συνδρομητικό πρόγραμμα στο οποίο βρίσκεστε είναι ένα δωρεάν πρόγραμμα, επομένως δεν απαιτείται πληρωμή από την πλευρά σας.",
                en: "The subscription plan you are under is a free plan, thus no payment is required from your side.",
                it: "Il piano di abbonamento è gratuito, quindi non è richiesto alcun pagamento da parte vostra."
            },
            paymentCards: {
                el: "Κάρτες Πληρωμών",
                en: "Payment Cards",
                it: "Carte di pagamento"
            },
            submit: {
                el: "Υποβολή",
                en: "Submit",
                it: "Invia" 
            },
            showDetails: {
                el: "Λεπτομέρειες",
                en: "Show Details",
                it: "Mostra dettagli"
            },
            noData: {
                el: "Δεν υπάρχουν δεδομένα",
                en: "No data available",
                it: "Nessun dato disponibile"
            },
            billingCompleted: {
                el: "Η τιμολόγηση σας για αυτή την περίοδο έχει ολοκληρωθεί.",
                en: "Your billing for this period has been completed.",
                it: "La fatturazione per questo periodo è stata completata."
            },
            useCodeBelowTopay: {
                el: "Παρακαλούμε χρησιμοποιήστε τον παρακάτω κωδικό για να πληρώσετε το λογαριασμό",
                en: "Please use the code bellow to pay the bill",
                it: "Per pagare il conto, utilizzare il codice qui sotto"
            },
            changePeriod: {
                el: "Αλλαγή περιόδου",
                en: "Change Period",
                it: "Periodo di variazione" 
            },
            dateDialogTitle: {
                el: "Αλλαγή περιόδου χρέωσης",
                en: "Change Billing Period",
                it: "Modifica del periodo di fatturazione"
            },
            chooseDate: {
                el: "Επιλέξτε την ημέρα",
                en: "Choose the date",
                it: "Seleziona il giorno"
            },	
            paymentMethodChange: {
                el: "Αλλαγή μεθόδου πληρωμής",
                en: "Change payment method",
                it: "Modifica del metodo di pagamento"
            },
            payNow: {
                el: "Πληρωμή",
                en: "Pay Now",
                it: "Paga ora"
            },	
            planChange: {
                el: "Αλλαγή Πλάνου Συνδρομής",
                en: "Change Subscription Plan",
                it: "Modifica del piano di abbonamento"
            },
            newSubscriptionPlan: {
                el: "Νέα Συνδρομή",
                en: "New Subscription Plan",
                it: "Nuovo piano di abbonamento"
            },
            selectA:{
                el: "Επιλέξτε μια ",
                en: "Select a ",
                it: "Selezionare un "
            },
            loadMore: {
                el: "Φόρτωση περισσότερων...",
                en: "Loading More...",
                it: "Per saperne di più..." 
            },
            unpaidBillings: {
                el: "Παλαιότερες ανεξόφλητες χρεώσεις",
                en: "Old Unpaid billings",
                it: "Vecchie fatture non pagate" 
            },
            
            deleteConfirmationMessage: {
                el: "Σίγουρα θέλεις να διαγράψεις το email ",
                en: "Are you sure you want to delete the email ",
                it: "Siete sicuri di voler eliminare la e-mail "
            },
            questionmark: {
                el: ";",
                en: "?",
                it: "?"
            },
            deleteEmail: {
                el: "Διαγραφή Email ",
                en: "Delete Email ",
                it: "Elimina e-mail"
            },
            addNewEmail: {
                el: "Προσθήκη νέου email",
                en: "Add New Email",
                it: "Aggiungi un nuovo indirizzo e-mail"
            },
            calculateBilling: {
                el: "Υπολογισμός χρέωσης",
                en: "Calculate Billing",
                it: "Calcolo della fatturazione" 
            },
            billingUpdated: {
                el: "Η τιμολόγηση έχει επανυπολογιστεί",
                en: "The billing has been recalculated",
                it: "La fatturazione è stata ricalcolata" 
            },
            paymentMethods: {
                el: "Μέθοδοι πληρωμών",
                en: "Payment Methods",
                it: "Metodi di pagamento"
            },
            addPaymentMethod: {
                el: "Προσθήκη Μεθόδου πληρωμής",
                en: "Add payment method",
                it: "Aggiungi metodo di pagamento"
            },
            type: {
                el: "Τύπος",
                en: "Type",
                it: "Tipo"
            },
            incomplete: {
                el: "ατελής",
                en: "incomplete",
                it: "incompleto"
            },
            failed: {
                el: "αποτυχία",
                en: "failed",
                it: "fallito"
            },
            completed: {
                el: "ολοκληρώθηκε",
                en: "completed",
                it: "completato"
            },
            processing: {
                el: "σε επεξεργασία",
                en: "processing",
                it: "precessione"
            },
        }
    })
};
